import axiosClient from ".";
class SignInAPI {
  static verify(data) {
    return axiosClient.post("/users/sign_in.json", data);
  }

  static logout() {
    return axiosClient.delete("/users/sign_out.json");
  }
}

export default SignInAPI;
